import styled from "styled-components";

export const Container = styled.div`
  display: flex;
  align-items: center;
  justify-content: space-around;
  width: 100%;
  height: fit-content;
  margin: 0 auto;
  padding: 0;
  background-color: #fff;
  align-items: flex-start;
  .about-img-container {
    display: none;
    width: 50%;
    height: fit-content;
    img {
      width: 100%;
      min-height: 500px;
    }
  }
  @media only screen and (min-width: 867px) {
    .about-img-container {
      display: flex;
    }
  }
`;

export const Wrapper = styled.div`
  display: block;
  height: 100%;
  width: 90%;
  @media only screen and (min-width: 867px) {
    display: flex;

    width: 50%;
  }
`;

export const TextContainer = styled.div`
  flex-basis: 50%;
  width: 100%;
  align-items: baseline;
  justify-content: baseline;
  height: 100%;
  h2 {
    font-size: 3rem;
    padding: 1% 2rem;
    text-align: center;
  }
  p {
    padding: 10% 2rem;
  }
  img {
    width: 100%;
  }
  @media only screen and (min-width: 867px) {
    .mobile-only {
      display: none;
    }
  }
`;
